import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class CategoryRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/product_categories');
    }

    async getAll() {
        // if (Cache.get('product-categories')) {
        //     return Cache.get('product-categories');
        // }

        return this.where('per_page', 1000).run().then((res) => {
            Cache.set('product-categories', res.data, 60 * 5 * 1000);
            return Cache.get('product-categories');
        });
    }
}
